import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const WHATSAPP_PHONE = '5493492587720';
const BANNER_ROTATION_MS = 3000;
const banners = [
    {
        src: '/banners/Banner_1.jpg',
        alt: 'Seguros Megatone.Net',
        whatsappMessage: 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.'
    },
    {
        src: '/banners/Banner_2.jpg',
        alt: 'Seguros Megatone.Net',
        whatsappMessage: 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.'
    },
    {
        src: '/banners/Banner_3.jpg',
        alt: 'Seguros Megatone.Net',
        whatsappMessage: 'Hola, vi la publicación en Marketplace y quiero recibir mas informacion.'
    }
];

const SidebarBannersWhatsappWeb = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const [selectedBanner, setSelectedBanner] = useState(null);

    useEffect(() => {
        if (selectedBanner) {
            return undefined;
        }

        const intervalId = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % banners.length);
        }, BANNER_ROTATION_MS);

        return () => clearInterval(intervalId);
    }, [selectedBanner]);

    const handleOpenModal = (banner) => {
        setSelectedBanner(banner);
    };

    const handleCloseModal = () => {
        setSelectedBanner(null);
    };

    const buildWhatsappLink = (banner) => (
        `https://web.whatsapp.com/send/?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(banner.whatsappMessage)}&type=phone_number&app_absent=0`
    );

    return (
        <>
            <div className="sidebar-banner-container mt-4 px-3 mb-4 text-center" style={{ width: '100%', overflow: 'hidden' }}>
                <style>
                    {`
                        @keyframes fadeInBanner {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }

                        body.mini-sidebar .sidebar-banner-container {
                            display: none !important;
                        }

                        .sidebar-banner-button {
                            background: transparent;
                            border: 0;
                            padding: 0;
                            width: 100%;
                            cursor: pointer;
                        }

                        .sidebar-banner-button:focus-visible {
                            outline: 2px solid #25d366;
                            outline-offset: 4px;
                            border-radius: 0.5rem;
                        }

                        .sidebar-banner-image {
                            display: block;
                            width: 100%;
                            height: auto;
                            object-fit: cover;
                            transition: transform 0.2s ease;
                        }

                        .sidebar-banner-button:hover .sidebar-banner-image {
                            transform: scale(1.02);
                        }

                        .sidebar-banner-modal-dialog {
                            max-width: 680px;
                        }

                        .sidebar-banner-modal-dialog .modal-content {
                            border: 0;
                            border-radius: 24px;
                            overflow: hidden;
                            background: linear-gradient(180deg, #ffffff 0%, #f6f8fb 100%);
                            box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
                        }

                        .sidebar-banner-modal-dialog .modal-header {
                            border-bottom: 0;
                            padding: 1.25rem 1.25rem 0.75rem;
                        }

                        .sidebar-banner-modal-dialog .modal-title {
                            color: #18212f;
                            font-size: 1.15rem;
                            font-weight: 700;
                        }

                        .sidebar-banner-modal-dialog .modal-body {
                            padding: 0 1.25rem 1rem;
                        }

                        .sidebar-banner-modal-dialog .modal-footer {
                            border-top: 0;
                            padding: 0 1.25rem 1.25rem;
                            gap: 0.75rem;
                        }

                        .sidebar-banner-preview {
                            background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
                            border: 1px solid rgba(148, 163, 184, 0.2);
                            border-radius: 20px;
                            padding: 1rem;
                        }

                        .sidebar-banner-preview img {
                            display: block;
                            width: auto;
                            max-width: min(100%, 520px);
                            max-height: 56vh;
                            margin: 0 auto;
                            object-fit: contain;
                        }

                        .sidebar-banner-caption {
                            color: #5b6472;
                            font-size: 0.95rem;
                            margin-top: 0.9rem;
                        }

                        .sidebar-banner-whatsapp-btn {
                            min-width: 150px;
                            border-radius: 12px;
                            font-weight: 600;
                            padding: 0.7rem 1rem;
                            border: 0;
                        }

                        .sidebar-banner-whatsapp-btn {
                            background: linear-gradient(135deg, #25d366 0%, #19b955 100%);
                            box-shadow: 0 12px 24px rgba(37, 211, 102, 0.22);
                        }

                        .sidebar-banner-whatsapp-btn:hover,
                        .sidebar-banner-whatsapp-btn:focus {
                            background: linear-gradient(135deg, #1fc55e 0%, #17a84d 100%);
                        }
                    `}
                </style>
                {banners.map((banner, index) => (
                    <button
                        key={banner.src}
                        type="button"
                        className="sidebar-banner-button"
                        onClick={() => handleOpenModal(banner)}
                        aria-label={`Abrir ${banner.alt}`}
                        style={{
                            display: index === currentImage ? 'block' : 'none',
                            animation: index === currentImage ? 'fadeInBanner 0.3s ease-in' : 'none'
                        }}
                    >
                        <img
                            src={banner.src}
                            alt={banner.alt}
                            className="sidebar-banner-image img-fluid rounded shadow-sm"
                        />
                    </button>
                ))}
            </div>

            <Modal
                show={Boolean(selectedBanner)}
                onHide={handleCloseModal}
                centered
                dialogClassName="sidebar-banner-modal-dialog"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{selectedBanner?.alt}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedBanner && (
                        <div className="sidebar-banner-preview">
                            <img
                                src={selectedBanner.src}
                                alt={selectedBanner.alt}
                                className="img-fluid rounded shadow-sm"
                            />
                            <p className="sidebar-banner-caption mb-0">
                                Si te interesa esta propuesta, abrimos el chat con el mensaje ya preparado.
                            </p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    {selectedBanner && (
                        <Button
                            as="a"
                            href={buildWhatsappLink(selectedBanner)}
                            target="_blank"
                            rel="noreferrer"
                            className="sidebar-banner-whatsapp-btn"
                        >
                            Consultar Asesor
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SidebarBannersWhatsappWeb;
